import Component from '../core/Component'
import keycode from 'keycode'
import { enableScroll, disableScroll } from '../services/Scroll'
import anime from 'animejs'
import EventBus from '../core/EventBus'
import { EVENTS } from '../core/Events'

export const STATES = {
    VISIBLE: 'is-visible',
    ACTIVE: 'is-active',
}

export default class PopupNav extends Component {
    constructor(element) {
        super(element)

        this.ref = {
            bg: null,
            content: null,
            links: [],
            separators: []
        }

        this.ref.links = [...this.element.querySelectorAll('a')]
    }

    prepare() {
        this.element.addEventListener('click', this.handleClick)
        EventBus.on(EVENTS.SWUP_CONTENT_REPLACED, this.handleSwupContentReplaced)
    }

    destroy() {
        this.close()
        document.removeEventListener('keydown', this.handleKeydown)
    }

    handleSwupContentReplaced = () => {
        const url = location.href.split('#')[0]
        this.ref.links.forEach(link => {
            if (link.href === url) {
                link.classList.add('is-active')
            } else {
                link.classList.remove('is-active')
            }
        })
    }

    handleClick = (event) => {
        if (!this.ref.content.contains(event.target)) {
            event.preventDefault()
            this.close()
        } else if (event.target.closest('a')) {
            this.close()
        }
    }

    handleKeydown = (event) => {
        if (keycode(event.keyCode) === 'esc') {
            this.close()
        }
    }

    toggle() {
        if (this.is(STATES.VISIBLE)) {
            this.close()
        } else {
            this.open()
        }
    }

    close() {
        if (!this.is(STATES.VISIBLE)) {
            return
        }
        enableScroll()
        document.removeEventListener('keydown', this.handleKeydown)
        this.element.classList.remove(STATES.ACTIVE)

        EventBus.emit(EVENTS.POPUPNAV_CLOSESTART)
        const animation = this.getAnimation()
        animation.complete = () => {
            this.element.classList.remove(STATES.VISIBLE)
            EventBus.emit(EVENTS.POPUPNAV_CLOSEEND)
        }
        animation.reverse()
        animation.play()
    }

    open() {
        if (this.is(STATES.VISIBLE)) {
            return
        }
        disableScroll()
        this.element.classList.add(STATES.ACTIVE)

        document.addEventListener('keydown', this.handleKeydown)
        this.element.classList.add(STATES.VISIBLE)
        EventBus.emit(EVENTS.POPUPNAV_OPENSTART)

        const animation = this.getAnimation()
        animation.complete = () => {
            EventBus.emit(EVENTS.POPUPNAV_OPENEND)
        }
        animation.reverse()
        animation.play()
    }

    getAnimation() {
        if (this.animation) {
            return this.animation
        }

        this.animation = anime.timeline({
            easing: 'easeInOutQuad',
            duration: 400,
        })

        this.animation
            .add({
                targets: this.ref.bg,
                opacity: ['0', '1'],
                transformOrigin: ['40% 0', '40% 0'],
                scaleX: ['3', '1'],
                duration: 800,
            })
            .add(
                {
                    targets: this.ref.links,
                    opacity: [0, 1],
                    transformOrigin: ['-300px 50%', '-300px 50%'],
                    scale: ['.8', '1'],
                    easing: 'easeOutQuart',
                    delay: anime.stagger(80),
                },
                '-=200'
            )
            .add(
                {
                    targets: this.ref.separators,
                    transformOrigin: ['0 0', '0 0'],
                    scale: ['0', '1'],
                    easing: 'easeOutQuart',
                    delay: anime.stagger(80),
                },
                '-=500'
            )
        this.animation.reverse()
        return this.animation
    }
}
